export default {
	"1bfe098ef779f3115e373f10dd8734cd": "該商品下已存在更優惠的訂單，待支付金額",
	"28b8eb041fa23be520e7d2e47b5bf270": "元",
	"2a7871065fc3ff143f5f895dd21fc06e": "去查看"
}
